import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSupabaseClient } from '../lib/supabase';

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const supabase = getSupabaseClient();

        // Supabase will automatically handle the hash fragment and exchange tokens
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();

        if (sessionError) {
          console.error('Auth session error:', sessionError);
          navigate('/login?error=auth_failed');
          return;
        }

        if (!session?.user) {
          console.error('No user session found');
          navigate('/login?error=no_session');
          return;
        }

        console.log('✅ Auth callback successful, user authenticated:', session.user.id);

        // Ensure profile exists with correct role
        try {
          const { data: existingProfile } = await supabase
            .from('profiles')
            .select('id, role')
            .eq('id', session.user.id)
            .maybeSingle();

          if (!existingProfile) {
            // Create profile if it doesn't exist
            const { error: profileError } = await supabase
              .from('profiles')
              .insert({
                id: session.user.id,
                email: session.user.email,
                role: 'guide',
                full_name: session.user.user_metadata?.full_name || null,
                phone: session.user.user_metadata?.phone || null,
              });

            if (profileError) {
              console.warn('Profile creation failed:', profileError);
            } else {
              console.log('✅ Profile created for guide');
            }
          }

          // Ensure guide record exists
          const { data: existingGuide } = await supabase
            .from('guides')
            .select('user_id')
            .eq('user_id', session.user.id)
            .maybeSingle();

          if (!existingGuide) {
            const { error: guideError } = await supabase
              .from('guides')
              .insert({
                user_id: session.user.id,
                status: 'pending',
              });

            if (guideError) {
              console.warn('Guide record creation failed:', guideError);
            } else {
              console.log('✅ Guide record created');
            }
          }
        } catch (setupError) {
          console.warn('Unable to complete profile/guide setup:', setupError);
        }

        // Redirect to onboarding or dashboard based on guide status
        const { data: guideData } = await supabase
          .from('guides')
          .select('status')
          .eq('user_id', session.user.id)
          .maybeSingle();

        if (guideData?.status === 'active') {
          navigate('/dashboard');
        } else {
          navigate('/onboarding');
        }

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login?error=unexpected');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-[#2C2731]"></div>
        <p className="text-sm text-[#2C2731]/70">Completing your account setup...</p>
      </div>
    </div>
  );
}